import { network } from 'services/network';

export const setComponent = (params) => {
    return network.post('api/bo/reporting/setComponent', params).then((response) => {
        return response.data;
    });
};
